import { createInjectionKey } from "../../_utils/index.mjs";
export const dropdownMenuInjectionKey = createInjectionKey('n-dropdown-menu');
export const dropdownInjectionKey = createInjectionKey('n-dropdown');
export const dropdownOptionInjectionKey = createInjectionKey('n-dropdown-option');